module.exports = __webpack_public_path__ + "static/media/unsplash-tesla-parking.f3195d02.jpg";